export default __webpack_public_path__ + "static/media/ourgoals.4fe7283d.png";